import { palette } from '@openx/components-core/lib/theme/paletteV2.ts';
import {
  type DealInsightsChannelKeysApi,
  type DealInsightsDirectnessKeysApi,
  type DealInsightsMediaTypeKeysApi,
  dealInsightsChannelKeysApi,
  dealInsightsDirectnessKeysApi,
  dealInsightsMediaTypeKeysApi,
} from '@openx/types/dealInsights.ts';

export const getColorFromDistributionKeys = (
  key: DealInsightsDirectnessKeysApi | DealInsightsChannelKeysApi | DealInsightsMediaTypeKeysApi
) => {
  const colorsMap = {
    [dealInsightsDirectnessKeysApi.TRUE]: palette.charts.indigo,
    [dealInsightsDirectnessKeysApi.FALSE]: palette.charts.orchid,
    [dealInsightsChannelKeysApi.SITE]: palette.charts.indigo,
    [dealInsightsChannelKeysApi.APP]: palette.charts.orchid,
    [dealInsightsMediaTypeKeysApi.CTV]: palette.charts.indigo,
    [dealInsightsMediaTypeKeysApi.DISPLAY]: palette.charts.orchid,
    [dealInsightsMediaTypeKeysApi.OLV]: palette.charts.lightBlue,
  };

  return colorsMap[key];
};
